import {
  Building2, Sparkles, Briefcase, Layers, HardHat, ShowerHead,
  ConciergeBell, Brush, Grid3x3, AppWindow, ShieldCheck, Trash2,
} from "lucide-react";

export const CONTACT = {
  phone: "786-918-1367",
  phoneHref: "tel:+17869181367",
  smsHref: "sms:+17869181367",
  email: "eccs.pros@gmail.com",
  emailHref: "mailto:eccs.pros@gmail.com",
  domain: "elitefacilitysolution.com",
  logo: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/8j6nvwr2_elite.png",
};

export const HERO_IMAGE =
  "https://images.pexels.com/photos/5567186/pexels-photo-5567186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export const SERVICES_INCLUDE = [
  { icon: Building2, title: "Commercial Cleaning", desc: "Comprehensive cleaning programs for any commercial facility." },
  { icon: Sparkles, title: "Janitorial Services", desc: "Daily, weekly and custom janitorial support." },
  { icon: Briefcase, title: "Office Cleaning", desc: "Healthy, productive workspaces every day." },
  { icon: Layers, title: "Floor Maintenance", desc: "Strip, wax, buff and restore all floor types." },
  { icon: HardHat, title: "New Construction Final Cleaning", desc: "Move-in ready detailing for builders." },
  { icon: Trash2, title: "Post-Construction Cleanup", desc: "Debris and dust removal after the build." },
  { icon: ShowerHead, title: "Restroom Sanitation", desc: "Hospital-grade restroom disinfection." },
  { icon: ConciergeBell, title: "Day Porter Services", desc: "On-site staff keeping facilities pristine." },
  { icon: Grid3x3, title: "Tile & Grout Cleaning", desc: "Restore tile to a like-new shine." },
  { icon: AppWindow, title: "Window Cleaning", desc: "Streak-free interior and exterior glass." },
  { icon: ShieldCheck, title: "Disinfection Services", desc: "High-touch-point sanitization protocols." },
];

export const INDUSTRIES = [
  "Corporate Offices", "Medical Facilities", "Dental Offices", "Retail Stores",
  "Warehouses", "Manufacturing Facilities", "Government Buildings", "Churches", "Fitness Centers",
];

export const DETAILED_SERVICES = [
  {
    id: "commercial",
    title: "Commercial Cleaning",
    intro: "Our commercial cleaning programs are designed to maintain professional work environments while reducing health risks and improving workplace appearance.",
    image: "https://images.unsplash.com/photo-1549637642-90187f64f420?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tasks: ["Dusting", "Surface Sanitization", "Trash Removal", "Vacuuming", "Mopping", "Restroom Cleaning", "Kitchen & Breakroom Cleaning", "High Touch Point Disinfection", "Glass Cleaning"],
  },
  {
    id: "janitorial",
    title: "Janitorial Services",
    intro: "Reliable daily, weekly, and customized janitorial services designed to keep your facility operating at its best.",
    image: "https://images.unsplash.com/photo-1672068090228-7cebc77c07d9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tasks: ["Daily Facility Cleaning", "Restroom Maintenance", "Trash Collection", "Common Area Cleaning", "Supply Replenishment", "Day Porter Services"],
  },
  {
    id: "office",
    title: "Office Cleaning",
    intro: "Maintain a professional and healthy work environment with our customized office cleaning solutions.",
    image: "https://images.unsplash.com/photo-1577412647305-991150c7d163?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tasks: ["Workstation Sanitization", "Conference Room Cleaning", "Lobby Maintenance", "Breakroom Cleaning", "Restroom Disinfection", "Carpet Vacuuming"],
  },
  {
    id: "floor",
    title: "Floor Maintenance",
    intro: "Protect your flooring investment with professional floor care programs that keep every surface looking its best.",
    image: "https://images.unsplash.com/photo-1718152421680-d1580e843cc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tasks: ["Strip & Wax", "Burnishing", "Buffing", "Scrubbing", "Tile & Grout Cleaning", "Vinyl Floor Care", "Concrete Floor Maintenance"],
  },
  {
    id: "construction",
    title: "New Construction Final Cleaning",
    intro: "We provide complete post-construction cleanup services for contractors, builders, and developers.",
    image: "https://images.unsplash.com/photo-1597974380476-fbf652dfe188?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    tasks: ["Dust Removal", "Window Cleaning", "Surface Detailing", "Debris Removal", "Fixture Cleaning", "Floor Cleaning", "Move-In Ready Preparation"],
  },
];

export const OWNERS_IMAGE = "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/iedyqbhd_WhatsApp%20Image%202026-06-22%20at%2010.50.47%20PM.jpeg";

const REAL = {
  lakefront: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/l6vw2eiu_WhatsApp%20Image%202026-06-22%20at%2010.50.47%20PM%20%281%29.jpeg",
  greenHome: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/pddq1v5s_WhatsApp%20Image%202026-06-22%20at%2010.50.47%20PM%20%282%29.jpeg",
  moveIn: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/ixs8evvz_WhatsApp%20Image%202026-06-22%20at%2010.50.47%20PM%20%284%29.jpeg",
  showroom: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/g67w0wds_WhatsApp%20Image%202026-06-22%20at%2010.50.47%20PM%20%283%29.jpeg",
  chickfila: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/gy698oqe_WhatsApp%20Image%202026-06-22%20at%2010.50.48%20PM%20%281%29.jpeg",
  warehouse: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/g4zpezc1_WhatsApp%20Image%202026-06-22%20at%2010.50.48%20PM.jpeg",
  concreteBA: "https://customer-assets.emergentagent.com/job_elite-maintenance-1/artifacts/r55e7q4f_WhatsApp%20Image%202026-06-22%20at%2010.50.48%20PM%20%282%29.jpeg",
};

export const GALLERY = [
  {
    category: "Floor Maintenance",
    name: "Warehouse Concrete Floor Cleaning",
    location: "Daytona Beach, FL",
    description: "Deep cleaning and polishing of a large commercial warehouse concrete floor for a bright, presentable finish.",
    image: REAL.warehouse,
    featured: true,
  },
  {
    category: "Floor Maintenance",
    name: "Concrete Floor Restoration — Before & After",
    location: "Ormond Beach, FL",
    description: "Stained and polished concrete floor restoration that transformed a dull commercial slab into a showroom-ready surface.",
    image: REAL.concreteBA,
    featured: true,
  },
  {
    category: "Construction Cleaning",
    name: "Luxury Lakefront Estate — Post-Construction",
    location: "St. Augustine, FL",
    description: "Complete post-construction final cleaning for a custom waterfront home — dust removal, fixture detailing and concrete floor cleanup.",
    image: REAL.lakefront,
    featured: true,
  },
  {
    category: "Construction Cleaning",
    name: "New Construction Final Clean",
    location: "Palm Coast, FL",
    description: "Move-in ready detailing for a newly built single-family home, including bathrooms, baseboards and new flooring.",
    image: REAL.greenHome,
    featured: true,
  },
  {
    category: "Office Cleaning",
    name: "Flooring Showroom & Office Detail",
    location: "Daytona Beach, FL",
    description: "Commercial office and flooring showroom cleaning — carpet care, workstations, breakroom and display areas.",
    image: REAL.showroom,
    featured: true,
  },
  {
    category: "Construction Cleaning",
    name: "Move-In Ready Detail",
    location: "Ormond Beach, FL",
    description: "Final construction cleanup and exterior debris removal to deliver a move-in ready property on schedule.",
    image: REAL.moveIn,
    featured: true,
  },
  {
    category: "Floor Maintenance",
    name: "Strip & Wax Project",
    location: "Ormond Beach, FL",
    description: "Complete strip and wax restoration on VCT retail flooring.",
    before: "https://images.unsplash.com/photo-1583639695539-c9f8a96d0a60?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    after: "https://images.unsplash.com/photo-1718152421680-d1580e843cc9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  },
  {
    category: "Floor Maintenance",
    name: "Tile Restoration & Burnishing",
    location: "Palm Coast, FL",
    description: "Deep tile & grout cleaning followed by high-speed burnishing.",
    before: "https://images.unsplash.com/photo-1563219125-1db796e20ff2?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    after: "https://images.pexels.com/photos/5567186/pexels-photo-5567186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    category: "Janitorial Services",
    name: "Daily Cleaning Program",
    location: "St. Augustine, FL",
    description: "Five-day-per-week janitorial program for an industrial property.",
    before: "https://images.unsplash.com/photo-1580256081112-e49377338b7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    after: "https://images.pexels.com/photos/34516670/pexels-photo-34516670.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const GALLERY_CATEGORIES = ["All", "Office Cleaning", "Floor Maintenance", "Construction Cleaning", "Janitorial Services"];

export const GOOGLE = {
  rating: 5.0,
  count: 11,
  snippet: "Awesome response time and they do a really great job.",
  profileUrl: "https://www.google.com/search?si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_1GVAcbmxtcK7t6I4QFgL6VHkQ4I74MzuVnUpd657rb6JNuaxmcx7--9299Od7z3gYcw8Bzpu00XiAxwAny60JG6OF9wEy3gHjNNOazWsVL4hadCsEjmpTPSlkkGSvCZxWUFL70%3D&q=Elite+Commercial+Cleaning+Service+Reviews",
};

export const TESTIMONIALS = [
  { quote: "Elite Facility Solutions consistently exceeds expectations. Their attention to detail and reliability make them an invaluable partner.", author: "Facilities Director", company: "Corporate Office" },
  { quote: "Our office has never looked better. Professional team and outstanding communication.", author: "Office Manager", company: "Professional Services Firm" },
  { quote: "Their post-construction cleaning team helped us deliver our project on schedule.", author: "Project Manager", company: "General Contractor" },
];

export const SERVICE_AREAS = ["Palm Coast", "Daytona Beach", "Ormond Beach", "Flagler Beach", "St. Augustine"];

export const STATS = [
  { value: "100%", label: "Satisfaction Focused" },
  { value: "12+", label: "Specialized Services" },
  { value: "24/7", label: "Flexible Scheduling" },
  { value: "5★", label: "Client-Rated Service" },
];

export const TRUST_BADGES = [
  "Fully Insured & Bonded",
  "Background-Checked Staff",
  "Eco-Friendly Products",
  "OSHA-Compliant Protocols",
  "Free On-Site Estimates",
];

export const FAQS = [
  { q: "How much does commercial cleaning cost?", a: "Pricing depends on your facility's square footage, cleaning frequency, and the services you need. Use our instant estimate calculator for a ballpark figure, then request a free walkthrough for an exact, no-obligation quote." },
  { q: "What areas do you serve?", a: "We provide commercial cleaning services throughout Northeast Florida, including Palm Coast, Daytona Beach, Ormond Beach, Flagler Beach, and St. Augustine." },
  { q: "Are you insured and bonded?", a: "Yes. Elite Facility Solutions is fully insured and bonded, and our cleaning professionals are background-checked and trained for commercial environments." },
  { q: "How often should my facility be cleaned?", a: "It depends on foot traffic and industry. Many offices choose weekly or nightly service, while medical and high-traffic facilities benefit from daily cleaning. We'll recommend a custom program during your free estimate." },
  { q: "Do you offer after-hours or weekend cleaning?", a: "Absolutely. We schedule around your operations — including nights and weekends — so cleaning never disrupts your business or customers." },
  { q: "Do you provide post-construction cleaning?", a: "Yes. Our new construction final cleaning service handles dust removal, debris, fixture detailing, window cleaning, and move-in ready preparation for builders and developers." },
];

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "Gallery", href: "#gallery" },
  { label: "Shop Supplies", href: "/supply" },
  { label: "Careers", href: "/careers" },
  { label: "Portal", href: "/portal" },
  { label: "Contact", href: "#contact" },
];
